import React, { useCallback } from 'react';
import { Field } from 'react-final-form';

import FormInput from 'Shared/components/FormComponents/FormInput';
import { nonEmptyStringRequired, required } from 'Shared/utils/formValidations';

import FormChooseRole from './FormChooseRole/FormChooseRole';

function FormFields() {
  const handleShowError = useCallback(({ value, touched, error }) => Boolean(touched && error && value), []);

  return (
    <div>
      <Field name="profile.role" validate={required} component={FormChooseRole} errorLabel={false} />
      <Field
        name="profile.fullName"
        placeholder="Full name"
        validate={nonEmptyStringRequired}
        onShowError={handleShowError}
        label="Name"
        className="mt-3"
        component={FormInput}
        labelMuted
      />
    </div>
  );
}

export default FormFields;
